var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filter-panel',{staticClass:"filters-panel",attrs:{"filter-parameters":_vm.formattedFilters,"notification-text":null,"api-request-data":null},on:{"update":_vm.applyFilter}})}
var staticRenderFns = []

export { render, staticRenderFns }